import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Collapse,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { fetchStudentDetails } from "../../../redux/Actions/studentDetailsActions";
import TeacherNavbar from "./TeacherNavbar";
import "./StudentDetails.css";

const StudentDetails = () => {
  const { studentId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    data: studentDetails,
    error,
  } = useSelector((state) => state.studentDetails);

  const [isEnrolledCoursesVisible, setIsEnrolledCoursesVisible] =
    useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  useEffect(() => {
    if (studentId) {
      dispatch(fetchStudentDetails(studentId));
    }
  }, [dispatch, studentId]);

  const handleBackClick = () => {
    navigate("/manage-students");
  };

  const toggleEnrolledCourses = () => {
    setIsEnrolledCoursesVisible((prevVisible) => !prevVisible);
  };

  return (
    <div className="student-details-layout">
      <TeacherNavbar />
      <Container className="student-details-container">
        <Box className="student-details-content">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="h4"
              gutterBottom
              className="student-details-title"
            >
              Student Details
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBackClick}
            >
              Back to Manage Students
            </Button>
          </Box>

          {loading && <Typography>Loading student details...</Typography>}
          {error && <Typography color="error">Error: {error}</Typography>}
          {studentDetails && (
            <>
              <Card className="student-info-card">
                <CardContent>
                  <Typography variant="h6">Personal Information</Typography>
                  <Typography variant="body2">
                    First Name: {studentDetails.firstName}
                  </Typography>
                  <Typography variant="body2">
                    Last Name: {studentDetails.lastName}
                  </Typography>
                  <Typography variant="body2">
                    Email: {studentDetails.email}
                  </Typography>
                  <Typography variant="body2">
                    Date of Birth: {studentDetails.dateOfBirth}
                  </Typography>
                  <Typography variant="body2">
                    Job: {studentDetails.job}
                  </Typography>
                  <Typography variant="body2">
                    Nationality: {studentDetails.nationality}
                  </Typography>
                  <Typography variant="body2">
                    Accommodation: {studentDetails.accommodation}
                  </Typography>
                  <Typography variant="body2">
                    Phone Number: {studentDetails.phoneNumber}
                  </Typography>
                </CardContent>
              </Card>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
              >
                <Typography variant="h6" className="enrolled-courses-title">
                  Enrolled Courses
                </Typography>
                <Button variant="outlined" onClick={toggleEnrolledCourses}>
                  {isEnrolledCoursesVisible ? "Hide Courses" : "Show Courses"}
                </Button>
              </Box>

              <Collapse in={isEnrolledCoursesVisible}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Course Title</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Grade</TableCell>
                      <TableCell>Hours Spent</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {studentDetails.enrolledCourses.map((course) => (
                      <TableRow key={course.teacherCourseId}>
                        <TableCell>{course.courseTitle}</TableCell>
                        <TableCell>{course.startDate}</TableCell>
                        <TableCell>{course.endDate}</TableCell>
                        <TableCell>{course.grade}</TableCell>
                        <TableCell>{course.hoursSpent}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Collapse>

              <Box mt={3}>
                <Typography variant="h6">Notify Student</Typography>
                <TextField
                  label="Enter your message"
                  multiline
                  rows={4}
                  fullWidth
                  value={notificationMessage}
                  onChange={(e) => setNotificationMessage(e.target.value)}
                  variant="outlined"
                  margin="normal"
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: "10px" }}
                >
                  Send Notification
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Container>
    </div>
  );
};

export default StudentDetails;
